module.exports = __webpack_public_path__ + "img/home-header.2dc20485.png";